<template>
  <div
    v-if="immediateTagging"
    class="container"
  >
    <Toolbar class="mt-2 mb-2">
      <template #start>
        <h2>{{ $t("nav.immediateTaggingDetail") }}</h2>
      </template>
    </Toolbar>
    <ImmediateTaggingDetail
      :immediate-tagging="immediateTagging"
    />

    <div
      v-if="isAgent"
    >
      <Toolbar>
        <template #start>
          <h2>{{ $t('entity.barcode.list') }}</h2>
        </template>
        <template #end>
          <Button
            class="p-button-rounded p-button-outlined"
            icon="pi pi-plus"
            :label="$t('action.crud.create')"
            @click="showCreatebarcodeForm = true"
          />
        </template>
      </Toolbar>

      <BarcodeCreateDialog
        v-model:visible="showCreatebarcodeForm"
        :immediate-tagging="immediateTagging"
        :stakeholder="immediateTagging.user.stakeholder"
        @create="getBarcodes"
      />

      <BarcodeTable
        v-model:sortField="barcodeFilter.pageable.sortField"
        v-model:sortOrder="barcodeFilter.pageable.sortOrder"
        v-model:filters="barcodeFilter.filters"
        v-model:rows="barcodeFilter.pageable.size"
        :paginator="true"
        paginator-position="both"
        :value="barcodes"
        :show-edit-button="true"
        :total-records="totalItemsCount"
        @sort="getBarcodes()"
        @filter="getBarcodes()"
        @page="onPageChange($event)"
        @delete="getBarcodes()"
      />
    </div>
  </div>
</template>
<script>
import ImmediateTaggingDetail from "@/components/immediatetagging/ImmediateTaggingDetail.vue";
import Toolbar from "primevue/toolbar";
import {CONTACT_ROLE} from "@/shared/constants";
import BarcodeTable from "@/components/barcodes/BarcodeTable";
import {computed, reactive} from "vue";
import useBarcodeFilter from "@/composables/filters/useBarcodeFilter";
import Button from "primevue/button";
import BarcodeCreateDialog from "@/components/barcodes/BarcodeCreateDialog.vue";

export default {
  name: 'ImmediateTaggingDetailView',
  components: {BarcodeCreateDialog, ImmediateTaggingDetail, Toolbar, BarcodeTable, Button},
  provide() {
    return {
      stakeholderId: computed(() => this.immediateTagging?.user.stakeholder.id),
      immediateTaggingId: computed(() => this.immediateTagging.id)
    }
  },
  setup() {
    const barcodeFilter = reactive(useBarcodeFilter());
    return {
      barcodeFilter
    }
  },
  data() {
    return {
      immediateTagging: null,
      barcodes: [],
      totalItemsCount: 0,
      showCreatebarcodeForm: false,
    }
  },
  computed: {
    isAgent() {
      return this.$store.state.auth.user.role !== CONTACT_ROLE;
    },
  },
  async mounted() {
    const {id} = this.$route.params;
    this.immediateTagging = await this.$immediateTaggingService.get(id);

    this.barcodeFilter.pageable.sortField = 'start';
    this.barcodeFilter.filters.stakeholder.value = this.immediateTagging.user.stakeholder.id;
    this.barcodeFilter.filters.deleted.value = false;
    await this.getBarcodes();
  },
  methods: {
    onPageChange(event) {
      this.barcodeFilter.pageable.page = event.page;
      this.getBarcodes();
    },
    async getBarcodes() {
      const params = this.barcodeFilter.getQueryParams();
      const result = await this.$barcodeService.getAll(params);
      this.barcodes = result.content;
      this.totalItemsCount = result.totalElements;
    }
  }
}
</script>
